<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="90%"
          persistent>            
    <v-card class="d-flex flex-column">
      <img
          :src="edicaoEvento.urlImgCapa"
          class="img-capa"
          alt="Capa do Evento"
        />      
      <v-card-title class="primary white--text">
        <div>
          <h3 class="headline mb-0">{{ edicaoEvento.descricao }}</h3>
        </div>
        <v-spacer/>
        <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>            
      </v-card-title>

      <v-divider/>
      <v-card-text class="py-4 flex-grow-1" v-if="value">
        <v-form ref="formInscricao" v-model="formValid" lazy-validation>
          <v-row dense class="pa-4">
            <!-- Inscrição realizada -->
            <v-col cols="12" class="mb-5" v-if="jaEstaInscrito">
              <v-sheet class="pa-4 rounded-lg" color="#e3f2fd" elevation="1">
                <div class="titulo-insc-realizada font-weight-medium mb-2">
                  <v-icon left color="green">mdi-check-circle</v-icon>
                  Inscrição realizada
                </div>
                <v-row>
                  <v-col cols="12" sm="6">
                      <span class="titulo-detalhe">Data Inscrição:</span><br>
                      <span class="detalhe">{{ edicaoEvento.dtInscricao | moment("DD/MM/YYYY") }}</span>
                  </v-col>
                  <v-col cols="12" sm="6">
                      <span class="titulo-detalhe">Situação:</span><br>
                      <span class="detalhe">{{ edicaoEvento.descStatus }}</span>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>            
            <!-- Cronograma -->
            <v-col cols="12" class="mb-2">
              <v-icon color="primary" class="mr-2">mdi-calendar</v-icon>
              <span class="titulo-detalhe font-weight-bold">Cronograma</span>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col
                  v-for="cronograma in edicaoEvento.cronograma"
                  :key="cronograma.id"
                  cols="12"
                  sm="6"
                  class="mb-1">
                  <v-card
                    class="cronograma-item pa-2"
                    :class="[
                      { 'cronograma-item--selected': cronogramaEstaSelecionado(cronograma) },
                      { 'cronograma-item--disabled': !autenticado || jaEstaInscrito }
                    ]"
                    outlined
                    hover
                    @click="(autenticado && !jaEstaInscrito) ? toggleCronograma(cronograma) : null">
                    <div class="d-flex align-start justify-space-between mb-1">
                      <div class="d-flex align-center">
                        <v-icon
                          class="mr-2"
                          :color="cronogramaEstaSelecionado(cronograma) ? 'success' : 'primary'">
                          {{ cronogramaEstaSelecionado(cronograma) ? 'mdi-checkbox-marked-circle' : 'mdi-calendar-range' }}
                        </v-icon>
                        <span class="detalhe font-weight-bold">{{ cronograma.data | moment("DD/MM/YYYY") }}</span>
                      </div>
                      <v-chip
                        v-if="cronogramaEstaSelecionado(cronograma) || (autenticado && !jaEstaInscrito)"
                        x-small
                        :color="cronogramaEstaSelecionado(cronograma) ? 'success' : 'grey lighten-2'"
                        :text-color="cronogramaEstaSelecionado(cronograma) ? 'white' : 'grey darken-2'"
                      >
                        {{ cronogramaEstaSelecionado(cronograma) ? 'Selecionado' : 'Clique para selecionar' }}
                      </v-chip>
                    </div>
                    <div class="d-flex align-center mb-0">
                      <v-icon small class="mr-1">mdi-clock-start</v-icon>
                      <span class="detalhe">{{ cronograma.horaInicio }}</span>
                      <span class="mx-1">-</span>
                      <v-icon small class="mr-1">mdi-clock-end</v-icon>
                      <span class="detalhe">{{ cronograma.horaFim }}</span>
                    </div>
                    <div class="d-flex align-start">
                      <v-icon small class="mr-1 mt-1">mdi-information</v-icon>
                      <span class="detalhe font-italic cronograma-descricao">{{ cronograma.descricao }}</span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <div
                v-if="showValidationErrors && validarCronogramaObrigatorio(inscricao.cronograma) !== true"
                class="error--text text-caption mt-1"
              >
                {{ validarCronogramaObrigatorio(inscricao.cronograma) }}
              </div>
            </v-col>

            <!-- Período de inscrição -->
            <v-col cols="12" md="3" class="mb-2 mt-4">
              <v-icon color="primary" class="mr-2">mdi-calendar-check</v-icon>
              <span class="titulo-detalhe font-weight-bold">Período de inscrição: </span>
              <span class="detalhe">
                {{ edicaoEvento.dtInicioInscricao | moment("DD/MM/YYYY") }} a
                {{ edicaoEvento.dtFimInscricao | moment("DD/MM/YYYY") }}
              </span>
            </v-col>

            <!-- Local -->
            <v-col cols="12" md="3" class="mb-2 mt-4">
              <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
              <span class="titulo-detalhe font-weight-bold">Local: </span>
              <span class="detalhe">{{ edicaoEvento.cidade }}/{{ edicaoEvento.estado }}</span>
            </v-col>

            <!-- Publico Alvo -->
            <v-col cols="12" md="3" class="mb-2 mt-4">
              <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
              <span class="titulo-detalhe font-weight-bold">Público Alvo: </span>
              <span class="detalhe">{{ descPublicoAlvo }}</span>
            </v-col>          

            <!-- Tipo de Inscrição -->
            <v-col cols="12" md="3" class="mb-2 mt-4">
              <v-icon color="primary" class="mr-2">mdi-ticket-confirmation-outline</v-icon>
              <span class="titulo-detalhe font-weight-bold">Inscrição: </span>
              <span class="detalhe">{{ edicaoEvento.descTipoAcessoEvento }}{{ infoPagamento }}</span>
            </v-col>          

            <!-- Mais informações -->
            <v-col cols="12" class="mb-2 mt-4">
              <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
              <span class="titulo-detalhe font-weight-bold">Mais informações</span>
            </v-col>
            <v-col cols="12">
              <span class="detalhe">{{ edicaoEvento.maisInfo }}</span>
            </v-col>
            
            <template v-if="autenticado">
              <!-- Demandas/Ofertas -->
              <v-col cols="12" class="mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                <span class="titulo-detalhe font-weight-bold">{{ getPerguntaOfertaDemanda }}</span>
              </v-col>
              <v-col cols="12">
                <search-box-multiple
                    :label="`* ${getTextoOfertaDemanda}s disponíveis`"
                    :disabled="jaEstaInscrito"
                    class="search-box-cursos"
                    :popup-label="`Clique no campo acima para visualizar as opções disponíveis e selecione as ${getTextoOfertaDemanda}s desejadas. Para filtrar mais resultados, digite parte do texto desejado.`"
                    v-model="inscricao.ofertaDemanda"
                    :loader-fn="loaderOfertasDemandas"
                    item-key="id"
                    item-text="descricaoCompleta"
                    :rules="[
                          validarOfertaDemandaObrigatoria,
                      ]">
                  <template v-slot:selection="{item}" >
                    <div class="curso-chip-wrap">
                      <div @click.stop class="curso-chip v-chip">
                        <v-icon class="mr-2" color="success" small>mdi-checkbox-marked-circle</v-icon>
                        <div class="item-description">{{item.descricaoCompleta}}</div>
                        <div v-show="!jaEstaInscrito" class="remove-button" @click="removeOfertaDemanda(item)">
                          <v-btn x-small icon class="ma-0 pa-0">
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:empty>
                    <p class="ma-2">
                      Nenhuma {{ getTextoOfertaDemanda }} encontrada.
                    </p>
                  </template>
                </search-box-multiple>
              </v-col>
              <!-- Mais informações -->
              <v-col cols="12" class="mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                <span class="titulo-detalhe font-weight-bold">{{ getTextoMaisDetalhes }}</span>
              </v-col>
              <v-col cols="12">
                <span class="detalhe">
                  <v-textarea
                    :disabled="jaEstaInscrito"
                    v-model="inscricao.maisDetalhe"
                    :label="`Detalhe da(s) sua(s) ${getTextoOfertaDemanda} para o evento`"
                    rows="4"
                    :rules="[
                          this.$validators.string.required,
                          v => this.$validators.string.lessThanOrEquals(v, 4000)
                        ]"
                    outlined
                  ></v-textarea>
                </span>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="success" @click="$emit('input', false)" :disabled="loading">Cancelar</v-btn>
        <v-btn color="primary" @click="save" v-show="autenticado && !jaEstaInscrito && !loading">Quero me inscrever</v-btn>        
      </v-card-actions>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </v-dialog>
</template>

<script>
import {createPorToken as salvarInscricao} from "@/api/eventoInscricao";
import {findAll as findAllOferta} from "@/api/oferta";
import {findAll as findAllOfertaFornecedor} from '@/api/ofertaFornecedor';
import SearchBoxMultiple from "@/components/shared/common/SearchBoxMultiple";
import {ApiError} from "@/api/core";

export default {
  name: "EfetivarIncricaoDialog",
  components: { SearchBoxMultiple },
  props: {
    value: {
      type: Boolean,
    },
    edicaoEvento: {
      type: Object
    },
    autenticacao: {
      type: Object
    },
    autenticado: {
      type: Boolean,
      default: false
    }    
  },  
  data () {
    return {
      formValid: false,
      showValidationErrors: false,
      loading: false,
      inscricao: {
        idEventoEdicao: null,
        idFornecedor: null,
        idComprador: null,
        idContato: null,
        maisDetalhe: "",
        cronograma: [],
        ofertaDemanda: [],
      },
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.resetInscricao();
      }
    }
  },
  computed: {
    jaEstaInscrito() {
      return this.edicaoEvento.inscrito === 1;
    },
    infoPagamento() {
      if (this.edicaoEvento.tipoAcessoEvento === 'P') {
        return ` - Valor: R$ ${this.edicaoEvento.valorInscricao}. O Sebrae enviará o link de pagamento por e-mail após a confirmação da inscrição.`;
      }
      return '';
    },
    getTextoMaisDetalhes() {
      if (this.autenticacao.dadosLogado.current.nivel === 'FOR') {
        return "Faça um resumo dos principais produtos/serviços ofertados por sua empresa.";
      } else if (this.autenticacao.dadosLogado.current.nivel === 'COM') {
        return "Detalhe sua necessidade de compra para o evento.";
      } else {
        return "";
      }
    },
    getTextoOfertaDemanda() {
      if (this.autenticacao.dadosLogado.current.nivel === 'FOR') {
        return "Oferta";
      } else if (this.autenticacao.dadosLogado.current.nivel === 'COM') {
        return "Demanda";
      } else {
        return "";
      }
    },
    getPerguntaOfertaDemanda() {
      if (this.autenticacao.dadosLogado.current.nivel === 'FOR') {
        return "Qual a sua oferta de produtos ou serviços?";
      } else if (this.autenticacao.dadosLogado.current.nivel === 'COM') {
        return "Qual a sua necessidade de compra para este evento?";
      } else {
        return "";
      }
    },
    getTitle() {
      return this.edicaoEvento?.id ? this.edicaoEvento.descricao : 'Ocorreu um erro'
    },
    descPublicoAlvo() {
      if (this.edicaoEvento.publicoAlvo === "FOR") return "Somente Fornecedores";
      if (this.edicaoEvento.publicoAlvo === "COM") return "Somente Compradores";
      if (this.edicaoEvento.publicoAlvo === "TOD") return "Compradores e Fornecedores";
      return "";
    },    
  },
  methods: {
    async resetInscricao() {
      this.showValidationErrors = false;
      this.inscricao = {
        idEventoEdicao: null,
        idFornecedor: null,
        idComprador: null,
        idContato: null,
        maisDetalhe: this.edicaoEvento.maisDetalheInscricao || "",
        cronograma: this.edicaoEvento.cronogramaInscricao || [],
        ofertaDemanda: this.edicaoEvento.ofertaDemanda || [],
      };

      // Para fornecedor autenticado ainda não inscrito, reaproveita automaticamente
      // todas as ofertas já associadas ao cadastro do fornecedor.
      const deveAutoPreencherOfertaFornecedor =
        this.autenticado &&
        !this.jaEstaInscrito &&
        this.autenticacao?.dadosLogado?.current?.nivel === 'FOR';

      if (deveAutoPreencherOfertaFornecedor) {
        await this.carregarOfertasFornecedor();
      }
    },
    async carregarOfertasFornecedor() {
      const ofertas = [];
      let paginaAtual = 1;
      let totalPaginas = 1;

      try {
        while (paginaAtual <= totalPaginas) {
          const resposta = await findAllOfertaFornecedor(paginaAtual, {});
          const elementos = Array.isArray(resposta?.elements) ? resposta.elements : [];

          elementos.forEach(item => {
            const idOferta = Number(item.idOferta);
            if (!Number.isFinite(idOferta) || idOferta <= 0) return;

            ofertas.push({
              id: idOferta,
              descricaoCompleta: item.descricaoOferta || '',
            });
          });

          totalPaginas = Number(resposta?.totalPages) || 0;
          if (totalPaginas === 0) break;
          paginaAtual += 1;
        }

        const ofertasUnicas = [];
        const ids = new Set();

        ofertas.forEach(item => {
          if (!ids.has(item.id)) {
            ids.add(item.id);
            ofertasUnicas.push(item);
          }
        });

        this.inscricao.ofertaDemanda = ofertasUnicas;
      } catch (err) {
        this.$toast.error('Não foi possível carregar automaticamente suas ofertas cadastradas.', {
          timeout: 6000
        });
      }
    },
    save(){
      if(parseInt(this.edicaoEvento.id) > 0) {
        if (!this.validarFormulario()) {
          this.$toast.error('Preencha os campos obrigatorios para continuar.', {
            timeout: 6000
          });
          return;
        }

        const resumoInscricao = this.gerarResumoInscricao();
        const larguraResumoInscricao = this.$vuetify.breakpoint.mobile ? '90vw' : '60%';
        this.$swal({
          title: ` Veja o resumo da sua inscrição antes de confirmar: `,
          width: larguraResumoInscricao,
          html: resumoInscricao,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Não, vou corrigir',
          confirmButtonText: 'Sim, quero confirmar',
          didOpen: () => {
            const htmlContainer = this.$swal.getHtmlContainer();
            htmlContainer.style.textAlign = 'left';
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.inscricao.idEventoEdicao = this.edicaoEvento.id;
            this.saveInscricao();
          }
        });
      } else {
        this.$toast.error(`Informe o Evento que quer participar.`, {
          timeout: 6000
        });
      }
    },
    validarCronogramaObrigatorio(value) {
      return Array.isArray(value) && value.length > 0
        ? true
        : 'Selecione pelo menos um cronograma.';
    },
    validarOfertaDemandaObrigatoria(value) {
      return Array.isArray(value) && value.length > 0
        ? true
        : `Selecione ao menos uma ${this.getTextoOfertaDemanda.toLowerCase()}.`;
    },
    validarFormulario() {
      this.showValidationErrors = true;
      const formularioValido = this.$refs.formInscricao ? this.$refs.formInscricao.validate() : true;
      const cronogramaValido = this.validarCronogramaObrigatorio(this.inscricao.cronograma) === true;
      return formularioValido && cronogramaValido;
    },
    async saveInscricao() {
      try {
        this.loading = true;

        const payload = {
          idEventoEdicao: this.inscricao.idEventoEdicao,
          idFornecedor: (this.autenticacao.dadosLogado.current.nivel === 'FOR' ? this.autenticacao.dadosLogado.current.id : null),
          idComprador: (this.autenticacao.dadosLogado.current.nivel === 'COM' ? this.autenticacao.dadosLogado.current.id : null),
          idContato: this.autenticacao.dadosLogado.current.idResponsavel,
          maisDetalhe: this.inscricao.maisDetalhe,
          cronograma: JSON.stringify(this.inscricao.cronograma.map(item => item.id)),
          ofertaDemanda: JSON.stringify(this.inscricao.ofertaDemanda.map(item => item.id)),
        };

        await salvarInscricao(payload)
        this.$swal({
            title: 'Sucesso',
            html: 'Inscrição realizada com sucesso! A inscrição está em análise e assim que for confirmada pelo SEBRAE, enviaremos um e-mail de notificação com os dados de sua inscrição e detalhes sobre o evento.',
            icon: 'success',
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,          
            confirmButtonText: 'Ok'
          });
        this.$emit('input', false);
        this.$emit('onSave');
      } catch (err) {
        let menssagemErro = '';
        if (err instanceof ApiError) {
          menssagemErro = this.formattedMessageAlert(err.message);
        } else {
          menssagemErro = `Ocorreu algum erro ao realizar sua inscrição. Entre em contato com a administração do SEBRAE!`;
        }
        this.$swal({
          title: 'Ocorreu um erro',
          html: menssagemErro,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok'
        });
      } finally {
        this.loading = false;
      }
    },
    removeOfertaDemanda(item) {
      this.inscricao.ofertaDemanda = this.inscricao.ofertaDemanda.filter(v => v.id !== item.id);
    },   
    cronogramaEstaSelecionado(cronograma) {
      return this.inscricao.cronograma.some(item => item.id === cronograma.id);
    },
    toggleCronograma(cronograma) {
      if (this.jaEstaInscrito) return;

      const selecionado = this.cronogramaEstaSelecionado(cronograma);
      if (selecionado) {
        this.inscricao.cronograma = this.inscricao.cronograma.filter(item => item.id !== cronograma.id);
      } else {
        this.inscricao.cronograma = [...this.inscricao.cronograma, cronograma];
      }
    },
    loaderOfertasDemandas(page, search) {
      return findAllOferta(page, {
        descricao: search
      })
    },
    gerarResumoInscricao() {
      let html = `
        <div style="background-color: #f5f5f5; padding: 16px; border-radius: 8px; text-align: left;">
          <div style="margin-bottom: 16px;">
            <h4 style="color: #2EAB66; margin-bottom: 8px;">Evento Selecionado</h4>
            <p style="margin: 0; font-weight: bold;">${this.edicaoEvento.descricao}</p>
          </div>
      `;
      html += `
        <div style="margin-bottom: 16px; border-top: 1px solid #ddd; padding-top: 12px;">
          <h4 style="color: #2EAB66; margin-bottom: 8px;">Inscrição:</h4>
          <p style="margin: 0; font-weight: bold;">${this.edicaoEvento.descTipoAcessoEvento}${this.infoPagamento}</p>
        </div>
      `;      

      // Resumo dos cronogramas
      if (this.inscricao.cronograma && this.inscricao.cronograma.length > 0) {
        html += `
          <div style="margin-bottom: 16px; border-top: 1px solid #ddd; padding-top: 12px;">
            <h4 style="color: #2EAB66; margin-bottom: 8px;">Cronogramas Selecionados</h4>
            <ul style="margin: 0; padding-left: 20px;">
        `;
        this.inscricao.cronograma.forEach(cron => {
          const dataCron = this.$options.filters.moment(cron.data, 'DD/MM/YYYY');
          html += `<li><strong>${dataCron}</strong> - ${cron.horaInicio} até ${cron.horaFim}</li>`;
        });
        html += `</ul></div>`;
      }

      // Resumo das ofertas/demandas
      if (this.inscricao.ofertaDemanda && this.inscricao.ofertaDemanda.length > 0) {
        html += `
          <div style="margin-bottom: 16px; border-top: 1px solid #ddd; padding-top: 12px;">
            <h4 style="color: #2EAB66; margin-bottom: 8px;">${this.getTextoOfertaDemanda}s Selecionadas</h4>
            <ul style="margin: 0; padding-left: 20px;">
        `;
        this.inscricao.ofertaDemanda.forEach(item => {
          html += `<li>${item.descricaoCompleta}</li>`;
        });
        html += `</ul></div>`;
      }

      // Detalhes/informações adicionais
      if (this.inscricao.maisDetalhe && this.inscricao.maisDetalhe.trim()) {
        html += `
          <div style="margin-bottom: 0; border-top: 1px solid #ddd; padding-top: 12px;">
            <h4 style="color: #2EAB66; margin-bottom: 8px;">Detalhes Informados</h4>
            <p style="margin: 0; padding: 8px; background-color: #fff; border: 1px solid #ddd; border-radius: 4px; white-space: normal; word-break: break-word; max-height: 150px; overflow-y: auto;">
              ${this.inscricao.maisDetalhe.trim()}
            </p>
          </div>
        `;
      }

      html += `</div>`;
      return html;
    },
  },
}
</script>

<style scoped lang="scss">
.img-capa {
  width: 100%;
  height: 200px; /* Define uma altura fixa para todas as imagens */
  display: block;
  object-fit: cover; /* Mantém a proporção sem distorcer, cortando se necessário */
  object-position: center; /* Centraliza a imagem na área delimitada */
  // border-radius: 8px; /* opcional: deixa a imagem com cantos arredondados */
}
.curso-chip {
  margin: 0 6px 0 0;
  padding-right: 0;
  cursor: initial;
  background-color: rgba(0,0,0,0.1);
  min-height: 32px;
  height: auto;
  border-radius: 16px;
  border: 1px solid #dedede;
  display: flex;
  justify-content: center;
  align-items: stretch;

  .item-description {
    min-width: 150px;
    max-width: none;
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    padding-right: 5px;
    padding-top: 6px;
    padding-bottom: 6px;
    line-height: 1.3;
  }
  .remove-button {
    min-height: 32px;
    cursor: pointer;
    background-color: rgba(0,0,0,0.2);
    border-left: 2px solid #dedede;
    padding: 5px 8px !important;
    display: flex;
    align-items: center;
    transition: background-color 0.5s ease 0s;
    &:hover {
      background-color: rgba(0,0,0,0.3);
    }
  }
}

.curso-chip-wrap {
  display: inline-flex;
  padding-top: 4px;
  padding-bottom: 4px;
}

.cronograma-item {
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  border-color: #dce9f4;
  min-height: 100%;
}
.cronograma-item--disabled {
  cursor: default !important;
  opacity: 0.7;
  pointer-events: none;
}

.cronograma-item:hover {
  transform: translateY(-1px);
  border-color: #167ABC;
}

.cronograma-item--selected {
  border-color: #2EAB66;
  box-shadow: 0 0 0 1px #2EAB66;
  background-color: #f2fbf6;
}

.cronograma-descricao {
  white-space: pre-line;
}
</style>